/*
(function () {

	'use strict';

	/!*global $:true *!/

	let cologicSortByTags = {

		initSortByTags: function () {

			// let that = this;
            //
			// this.showToTop();
			// this.setBurger();
			// this.enableAccordion();
			// // this.navigationHandling();
			// // this.setYoutubeBox();
            //
			// $('.toTopWrapper').click(this.pageToTop);
			// // $(window).scroll(function () {
			// // 	that.setBackgroundImages();
			// // 	that.showToTop();
			// // });
			// // setTimeout(function () {
			// // 	that.setBackgroundImages()
			// // }, 1500);
            //
			// this.equalHeight();

		},


        identifyDataTags: function (_classes) {
            if (typeof(_classes) != 'undefined' && _classes != null && _classes !== ''){
                let dataTags = [];
                _classes.forEach((_class)=>{
                    $(_class).each(function(){
                        let json_data = $(this).data();
                        for(let i in json_data){
                            if(typeof(dataTags[i]) != 'undefined'){
                                dataTags[i].push(json_data [i].trim().split(' '));
                            }else{
                                dataTags[i] = [];
                                dataTags[i].push(json_data [i].trim().split(' '));
                            }
                        }
                    });
                });
                return dataTags;
            }else{
                return [];
            }
		},



        enableTagButtonsForDataTags: function (_dataTags) {
            let out = '';
            // out += '<h3 class="tagSectionHead">Aktuelle Kategorien (zum ein-/ausblenden klicken)</h3>';
            out += '<div class="tagSection pt-2">';
            let procArray = [];
            for(let i in _dataTags){
                procArray[i] = [];
                // console.log(i);
                // console.log(_dataTags[i]);
                // console.log(_dataTags[i]);
                // if(_dataTags[i][0] != ''){
                    _dataTags[i].forEach((selectTag) =>{
                        // console.log(selectTag);
                            selectTag.forEach((tag) => {
                                if(typeof(procArray[i][tag]) == 'undefined') {
                                    if(tag != ''){
                                        procArray[i][tag] = 1;
                                        let fineTag = tag.charAt(0).toUpperCase()  + tag.slice(1)
                                        out += '<div class="btn tagBtn active" data-wert="' + tag + '" data-kategorie="' + i + '">' + fineTag + '</div>';
                                    }
                                }
                            });
                    });
                    // out += '</div>';
                // }
            }
            out += '</div>';
            $('.crawlContainer ').prepend(out);
            // if (typeof(_dataTags) != 'undefined' && _dataTags != null && _dataTags !== '' && _dataTags.length > 0){
            //     _dataTags.forEach((_dataTag)=>{
            //         console.log(_dataTag);
            //     });
            // }
            $('.tagBtn').each(function (){
                $(this).bind('click', function(){
                    let that = this;
                    $('.tagBtn').each(function (){
                        if(!$(this).hasClass('active')){
                            let kategorie = $(this).data('kategorie');
                            let wert = $(this).data('wert');
                            let found = false;
                            $('.probo').each(function(){
                                if($(this).data(kategorie).indexOf(wert) != -1){
                                    // $(this).toggleClass(kategorie);
                                    // $(this).toggleClass(wert);
                                    $(this).parent().parent().removeClass('active');
                                }
                            });
                        }

                    });
                    let kategorie = $(this).data('kategorie');
                    let wert = $(this).data('wert');
                    let found = false;
                    $('.probo').each(function(){
                        if($(this).data(kategorie).indexOf(wert) != -1){
                            found = true;
                            // $(this).toggleClass(kategorie);
                            // $(this).toggleClass(wert);
                            if($(that).hasClass('active')) {
                                $(this).parent().parent().removeClass('active');
                            }else{
                                $(this).parent().parent().addClass('active');
                            }
                        }
                    });
                    if(found){
                        $(this).toggleClass('active');
                    }



                })
            });
		},






	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicSortByTags);
}());*/
